import { IRateResSchema } from '@monetize/types/app';
import { MAccordion, MStack } from '../../../../../components/Monetize';
import { CustomRateAccordionItem } from './CustomRateAccordionItem';

interface CustomRateItemsAccordionProps {
  customRates: IRateResSchema[];
}

export const CustomRateItemsAccordion = ({
  customRates,
}: CustomRateItemsAccordionProps) => {
  return (
    <MStack w="100%" mt={4} gap={2}>
      <MAccordion collapsible variant="default">
        {customRates.map(
          (
            { id, name, accountName, accountId, createDate, currency },
            index,
          ) => {
            return (
              <CustomRateAccordionItem
                data-testid="custom-rate-accordion-item"
                key={id}
                value={String(index)}
                rateId={id}
                name={name}
                createDate={createDate}
                accountName={accountName ?? ''}
                accountId={accountId ?? ''}
                currency={currency}
              />
            );
          },
        )}
      </MAccordion>
    </MStack>
  );
};
